import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

// Modules
import aside from '@/store/modules/aside';
import auth from '@/store/modules/auth';
import bb_articles from '@/store/modules/bb_articles';
import bb_tags from '@/store/modules/bb_tags';
import bb_widgets from '@/store/modules/bb_widgets';
import bb_widget_positions from '@/store/modules/bb_widget_positions';
import companies from '@/store/modules/companies';
import dialog from '@/store/modules/dialog';
import faq from '@/store/modules/faq';
import menu from '@/store/modules/menu';
import news from '@/store/modules/news';
import project from '@/store/modules/project';
import templates from '@/store/modules/templates';
import user from '@/store/modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  state,

  mutations,

  actions,

  getters,

  modules: {
    aside,
    auth,
    bb_articles,
    bb_tags,
    bb_widgets,
    bb_widget_positions,
    companies,
    dialog,
    faq,
    menu,
    news,
    project,
    templates,
    user
  }
});
